// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"a56b1ebd","352":"6d154d23","454":"5cb7865e","787":"82ea8e80","865":"fd683c7b","898":"9feff0d7","920":"b8e5f05e","935":"4d09c5ab"}[chunkId] + ".chunk.js";
};